var l={formField:"lds-form-field",label:"lds-form-field--label",error:"lds-form-field--error"};export{l as default};
